import { CopyOutlined, ExportOutlined } from '@ant-design/icons'
import { BlobProvider, Font } from '@react-pdf/renderer'
import {
  Button,
  Card,
  Checkbox,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Popconfirm,
  Radio,
  Row,
  Select,
  Steps,
  Tabs,
  Tag,
  Typography,
} from 'antd'
import _ from 'lodash'

import React, { useEffect, useRef } from 'react'

import {
  Batch,
  Member,
  PoojaMemberData,
} from '@a4b/api/src/modules/Monetisation/Offerings/types'

import '../../../../../../../src/Style.css'
import BatchPrintView from '@a4b/ui/src/modules/monetisation/molecules/BatchPrintView'
import S3Upload, { AllowedFormats } from '@a4b/ui/src/modules/monetisation/molecules/S3Upload'
import { generateNameListText } from '../../utils/helper'
import { copyToClipboard } from '@/utils/helper'

declare global {
  interface Window {
    XLSX: any
  }
}
Font.register({
  family: 'Noto Sans Hindi',
  fonts: [
    {
      src: `/Noto_Sans/NotoSans-Regular.ttf`,
    },
    {
      src: `/Noto_Sans/NotoSans-Bold.ttf`,
      fontWeight: 'bold',
    },
  ],
})
const { TabPane } = Tabs
const { Step } = Steps
const { Option } = Select
interface Props {
  onClose: () => void
  visible: boolean
  batchData: Batch | undefined
  handleNameListExport: () => void
  handlePrayerExport: () => void
  currentStep: number
  cdnUrl: string
  preSignUrl: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  orderMediaUploadForm: any
  handleFormSubmit: () => void
  handleOrderMediaFormSubmit: (formFlag: boolean) => void
  isPreviewDone: boolean
  openPreview: () => void
  onFormChange: () => void
}

const BatchView: React.FC<Props> = ({
  onClose,
  visible,
  batchData,
  handleNameListExport,
  handlePrayerExport,
  currentStep,
  cdnUrl,
  preSignUrl,
  form,
  handleFormSubmit,
  isPreviewDone,
  openPreview,
  onFormChange,
  orderMediaUploadForm,
  handleOrderMediaFormSubmit,
}) => {
  const refTable: any = useRef()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function downloadBlob(blob: any, name: string) {
    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = data
    link.download = name

    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    )

    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data)
      link.remove()
    }, 100)
  }
  let findMaxMembersCount: number[] = []
  if (batchData?.product_type === "pooja") {
    const max = batchData?.pooja_member_data?.reduce((prev: PoojaMemberData, current: PoojaMemberData) => {
      return (prev?.members?.length > current?.members?.length) ? prev : current
    })
    findMaxMembersCount = Array.from({ length: Number(max?.members?.length) }).map((u, i) => i)
  }

  const handleCopy = async (value: string) => {
    const success = await copyToClipboard(value);
    if (success) {
      message.success('Name list copied to clipboard', 2);
    } else {
      message.error('Failed to copy to clipboard', 2);
    }
  };

  return (
    <Drawer
      width={1000}
      title='Batch view'
      placement='right'
      size='large'
      onClose={onClose}
      visible={visible}
    >
      <>
        <Card>
          <Row>
            <Col span={18}>
              <Row>
                <Col span={8}>
                  <Typography.Title level={5}>Batch ID/Code</Typography.Title>
                </Col>
                <Col span={16}>{batchData?.batch_id}</Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Typography.Title level={5}>SKU Name</Typography.Title>
                </Col>
                <Col span={16}>{batchData?.product_name}</Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Typography.Title level={5}>No. of Items</Typography.Title>
                </Col>
                <Col span={16}>{batchData?.no_of_items}</Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Typography.Title level={5}>Temple Name</Typography.Title>
                </Col>
                <Col span={16}>{batchData?.store_name}</Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Typography.Title level={5}>Product Type</Typography.Title>
                </Col>
                <Col span={16}>{batchData?.product_type}</Col>
              </Row>
            </Col>
            <Col span={6}>
              <Row style={{ height: '100%' }}>
                <Col
                  span={24}
                  style={{ alignSelf: 'center', justifySelf: 'center' }}
                >
                  <Tag color={'blue'}>
                    {batchData?.status === 'created'
                      ? 'In Progress'
                      : 'Completed'}
                  </Tag>
                </Col>
                <Col
                  span={24}
                  style={{ alignSelf: 'center', justifySelf: 'center' }}
                >
                  <Button
                    type='default'
                    onClick={() => {
                      handleCopy(generateNameListText(batchData))
                    }}
                  >
                    <CopyOutlined />
                    Copy Name List
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Row>
          <Col span={24}>
            <Tabs
              defaultActiveKey='1'
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onChange={(info: any) => {
                console.log('Tab changed:', info)
              }}
              centered
            >
              <TabPane tab='Order Progression' key='1'>
                <Steps direction='vertical' current={currentStep}>
                  <Step
                    title='Order Created'
                    description={
                      <div>{`This batch was created with ${batchData?.no_of_items} items`}</div>
                    }
                  />
                  {(batchData?.product_type === 'pooja' || batchData?.product_type === 'item') && (
                    <Step
                      title='Order Media Upload'
                      description={
                        <div>
                          {currentStep === 1 ? (
                            <Form form={orderMediaUploadForm}>
                              <Row>
                                <Col span={24}>
                                  <Form.Item
                                    label='Order Media Type'
                                    name='order_media_type'
                                    rules={[
                                      {
                                        required: false,
                                        message:
                                          'Please select order media type!',
                                      },
                                    ]}
                                  >
                                    <Radio.Group>
                                      <Radio value={'video'}>Video</Radio>
                                      <Radio value={'image'}>Image</Radio>
                                    </Radio.Group>
                                  </Form.Item>
                                </Col>
                                <Col span={batchData?.product_type === 'item' ? 12 : 24}>
                                  <Form.Item
                                    noStyle
                                    shouldUpdate={(prevValues, currentValues) =>
                                      prevValues.order_media_type !==
                                      currentValues.order_media_type
                                    }
                                  >
                                    {({ getFieldValue }) =>
                                      getFieldValue('order_media_type') ===
                                      'video' && (
                                        <Form.Item
                                          label='Order Media'
                                          name='order_media'
                                          labelCol={{ span: 24 }}
                                          wrapperCol={{ span: 24 }}
                                          valuePropName='fileList'
                                          rules={[
                                            {
                                              min: 0,
                                              max: 15,
                                              validator: async (
                                                rules: any,
                                                values: any,
                                              ) => {
                                                if (
                                                  values?.length < rules.min
                                                ) {
                                                  return Promise.reject(
                                                    'Please upload MP4 media url',
                                                  )
                                                }
                                              },
                                            },
                                          ]}
                                        >
                                          <S3Upload
                                            cdnUrl={cdnUrl}
                                            preSignUrl={preSignUrl}
                                            allowedFileExtension={[
                                              AllowedFormats.MP4,
                                            ]}
                                            min={0}
                                            max={15}
                                          />
                                        </Form.Item>
                                      )
                                    }
                                  </Form.Item>
                                  <Form.Item
                                    noStyle
                                    shouldUpdate={(prevValues, currentValues) =>
                                      prevValues.order_media_type !==
                                      currentValues.order_media_type
                                    }
                                  >
                                    {({ getFieldValue }) =>
                                      getFieldValue('order_media_type') ===
                                      'image' && (
                                        <Form.Item
                                          label='Order Media'
                                          name='order_media'
                                          labelCol={{ span: 24 }}
                                          wrapperCol={{ span: 24 }}
                                          valuePropName='fileList'
                                          rules={[
                                            {
                                              min: 0,
                                              max: 15,
                                              validator: async (
                                                rules: any,
                                                values: any,
                                              ) => {
                                                if (
                                                  values?.length < rules.min
                                                ) {
                                                  return Promise.reject(
                                                    'Please upload image ',
                                                  )
                                                }
                                              },
                                            },
                                          ]}
                                        >
                                          <S3Upload
                                            cdnUrl={cdnUrl}
                                            preSignUrl={preSignUrl}
                                            allowedFileExtension={[
                                              AllowedFormats.PNG,
                                              AllowedFormats.JPEG,
                                              AllowedFormats.WEBP,
                                            ]}
                                            min={0}
                                            max={15}
                                          />
                                        </Form.Item>
                                      )
                                    }
                                  </Form.Item>
                                </Col>
                                {batchData?.product_type === 'item' &&
                                  <Col span={24}>
                                    <Form.Item
                                      label='Is Sankalp Media'
                                      name='is_sankalp_media'
                                      valuePropName='checked'
                                      rules={[
                                        {
                                          required: false,
                                          message: '',
                                        },
                                      ]}
                                    >
                                      <Checkbox />
                                    </Form.Item>
                                  </Col>
                                }
                                <Col span={12}>
                                  <Form.Item
                                    noStyle
                                    shouldUpdate={(prevValues, currentValues) =>
                                      prevValues.is_sankalp_media !==
                                      currentValues.is_sankalp_media
                                    }
                                  >
                                    {({ getFieldValue }) =>
                                      getFieldValue('is_sankalp_media') ===
                                        true && batchData?.product_type === 'item' ? <Popconfirm
                                          title="Are you sure You want to upload as a sankalp media ?"
                                          onConfirm={() =>
                                            handleOrderMediaFormSubmit(true)
                                          }
                                          okText="Yes"
                                          cancelText="No"
                                        >
                                        <Button
                                          type='primary'
                                        >
                                          Submit
                                        </Button>
                                      </Popconfirm> :
                                        <Button
                                          type='primary'
                                          onClick={() =>
                                            handleOrderMediaFormSubmit(true)
                                          }
                                        >
                                          Submit
                                        </Button>
                                    }
                                  </Form.Item>


                                </Col>
                                <Col span={12}>
                                  <Button
                                    type='primary'
                                    onClick={() =>
                                      handleOrderMediaFormSubmit(false)
                                    }
                                  >
                                    Skip Upload
                                  </Button>
                                </Col>
                              </Row>
                            </Form>
                          ) : (
                            <Row>
                              <Col span={24}>Done Order media upload</Col>
                            </Row>
                          )}
                        </div>
                      }
                    />
                  )}
                  {batchData?.product_type === 'prayer' && (
                    <Step
                      title='Export Prayer List'
                      description={
                        <div>
                          <BlobProvider
                            document={
                              <BatchPrintView
                                batchData={batchData}
                                dataType='prayer_list'
                              />
                            }
                          >
                            {({ blob, loading }) =>
                              loading ? (
                                'Loading document...'
                              ) : (
                                <Button
                                  type='primary'
                                  onClick={() => {
                                    downloadBlob(
                                      blob,
                                      `prayer_${batchData?.batch_id}.pdf`,
                                    )
                                    handlePrayerExport()
                                  }}
                                >
                                  <ExportOutlined />
                                  Export Prayer
                                </Button>
                              )
                            }
                          </BlobProvider>
                        </div>
                      }
                    />
                  )}
                  {/* <Step
                    title='Export name List'
                    description={
                      <div>
                        {(batchData?.product_type === 'pooja'
                          ? currentStep === 2
                          : currentStep === 1) &&
                          (batchData?.product_type === 'pooja' ? (
                            <Col span={24}>
                              <Button
                                type='primary'
                                onClick={() => {
                                  const wb =
                                    window?.XLSX?.utils?.table_to_book?.(
                                      refTable.current,
                                    )
                                  window?.XLSX?.writeFile(
                                    wb,
                                    `namelist_${batchData?.batch_id}.xlsx`,
                                  )
                                  handleNameListExport()
                                }}
                              >
                                <ExportOutlined />
                                Export Name List
                              </Button>
                            </Col>
                          ) : (
                            <BlobProvider
                              document={
                                <BatchPrintView
                                  batchData={batchData}
                                  dataType='name_list'
                                />
                              }
                            >
                              {({ blob, loading }) =>
                                loading ? (
                                  'Loading document...'
                                ) : (
                                  <Button
                                    type='primary'
                                    onClick={() => {
                                      downloadBlob(
                                        blob,
                                        `namelist_${batchData?.batch_id}.pdf`,
                                      )
                                      handleNameListExport()
                                    }}
                                  >
                                    <ExportOutlined />
                                    Export Name List
                                  </Button>
                                )
                              }
                            </BlobProvider>
                          ))}
                        {(batchData?.product_type === 'pooja'
                          ? currentStep === 3
                          : currentStep === 2) && (
                            <div>Name list exported sucessfully</div>
                          )}
                      </div>
                    }
                  /> */}
                  <Step
                    title='Upload Video'
                    description={
                      <div>
                        <span>
                          {batchData?.product_type === 'pooja'
                            ? `Update the status here, once the pooja is done`
                            : `Update the status here, once the offering is completed`}
                        </span>
                        {(batchData?.product_type === 'pooja'
                          ? currentStep === 3
                          : currentStep === 2) && (
                            <div>
                              <Form
                                form={form}
                                layout='vertical'
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                onFieldsChange={onFormChange}
                              >

                                <Form.Item
                                  label="Media type"
                                  name="videoType"
                                  labelCol={{ span: 12 }}
                                  wrapperCol={{ span: 12 }}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select media type!',
                                    },
                                  ]}
                                >
                                  <Select placeholder='Type'>
                                    <Option value='video'>Video</Option>
                                    <Option value='youtube'>Youtube</Option>
                                  </Select>
                                </Form.Item>

                                <Form.Item
                                  noStyle
                                  shouldUpdate={(prevValues, currentValues) =>
                                    prevValues.videoType !== currentValues.videoType
                                  }
                                >
                                  {({ getFieldValue }) => (
                                    getFieldValue("videoType") === "video" &&
                                    <Form.Item
                                      label='Video URL'
                                      name='video_url'
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      rules={[
                                        {
                                          min: 1,
                                          max: 1,
                                          validator: async (
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            rules: any,
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            values: any,
                                          ) => {
                                            if (values?.length < rules.min) {
                                              return Promise.reject(
                                                'Please upload Video',
                                              )
                                            }
                                          },
                                        },
                                      ]}
                                    >
                                      <S3Upload
                                        cdnUrl={cdnUrl}
                                        preSignUrl={preSignUrl}
                                        min={1}
                                        max={1}
                                        // preserveFilename={true}
                                        allowedFileExtension={[AllowedFormats.MP4]}
                                      />
                                    </Form.Item>
                                  )}

                                </Form.Item>

                                <Form.Item
                                  noStyle
                                  shouldUpdate={(prevValues, currentValues) =>
                                    prevValues.videoType !== currentValues.videoType
                                  }
                                >

                                  {({ getFieldValue }) => (
                                    getFieldValue("videoType") === "youtube" &&

                                    <Form.Item
                                      label='Youtube video link'
                                      name='video_url'
                                      labelCol={{ span: 12 }}
                                      wrapperCol={{ span: 12 }}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            'Please input youtube video link!',
                                        },
                                      ]}
                                    >
                                      <Input placeholder='Enter youtube video link' />
                                    </Form.Item>
                                  )}
                                </Form.Item>

                                <Row>
                                  {batchData?.status === 'failed' && (
                                    <Col span={24}>
                                      <Form.Item
                                        name="force_upload"
                                        valuePropName="checked"
                                        wrapperCol={{ span: 12 }}
                                      >
                                        <Checkbox>Force Upload</Checkbox>
                                      </Form.Item>
                                    </Col>
                                  )}
                                  <Col span={6}>
                                    <Form.Item shouldUpdate>
                                      {() =>
                                        form
                                          .getFieldsError()
                                          .filter(
                                            ({ errors }: any) => errors.length,
                                          ).length > 0 || !isPreviewDone ? (
                                          <Button type='primary' disabled={true}>
                                            Submit
                                          </Button>
                                        ) : (
                                          <Popconfirm
                                            placement='topLeft'
                                            title={
                                              'This video has been published on the aplication. are you sure to update this video?'
                                            }
                                            onConfirm={handleFormSubmit}
                                            okText='Yes Submit'
                                            cancelText='No'
                                          >
                                            <Button type='primary'>Submit</Button>
                                          </Popconfirm>
                                        )
                                      }
                                    </Form.Item>
                                  </Col>
                                  <Col span={6}>
                                    <Form.Item shouldUpdate className='submit'>
                                      {() => {
                                        return form
                                          .getFieldsError()
                                          .filter(
                                            ({ errors }: any) => errors.length,
                                          ).length > 0 ? (
                                          <Button type='primary' disabled={true}>
                                            Preview
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={openPreview}
                                            type='primary'
                                          >
                                            Preview
                                          </Button>
                                        )
                                      }}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          )}
                      </div>
                    }
                  />
                </Steps>
                {batchData?.product_type === "pooja" && <table hidden ref={refTable} className='puja-table'>
                  <thead>
                    <tr>
                      <th>Pooja Name / ID</th>
                      <th>SKU ID</th>
                      <th>Gotra</th>
                      {findMaxMembersCount?.map(
                        (item: number, index: number) => (
                          <th key={index}>Name {index + 1}</th>
                        ),
                      )}

                      <th>Phone Number</th>
                      <th>WhatsApp Number</th>
                      <th>Opted for prasad</th>
                      <th>Address</th>
                      <th>Pincode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchData?.pooja_member_data?.map(
                      (pujamembers: PoojaMemberData, index: number) => {
                        return (<tr key={index}>
                          <td>{batchData?.product_name}</td>
                          <td>{batchData?.inventory_id}</td>
                          <td>{pujamembers?.gotra}</td>
                          {findMaxMembersCount?.map(
                            (index: number) => (
                              <>
                                {<td key={index}>{pujamembers?.members?.[index]?.full_name}</td>}
                              </>
                            ),
                          )}
                          <td>{pujamembers?.mobile_number}</td>
                          <td>{pujamembers?.whatsapp_number}</td>
                          <td>{pujamembers?.is_opted_for_prasad ? "Yes" : "No"}</td>
                          <td>
                            {`${pujamembers?.booking_address?.house_info},${pujamembers?.booking_address?.area_info}`}
                            <br />
                            {`${pujamembers?.booking_address?.city_name},${pujamembers?.booking_address?.landmark}`}
                            <br />
                            {`${pujamembers?.booking_address?.state_name}`}
                          </td>
                          <td>
                            {pujamembers?.booking_address?.pin_code}
                          </td>
                        </tr>)
                      }

                    )}
                  </tbody>
                </table>}
              </TabPane>
              <TabPane tab='Name List' key='2'>
                {batchData?.product_type === 'pooja' ? (
                  <Row justify='end'>
                    <Col span={24}>
                      <Button
                        type='primary'
                        onClick={() => {
                          const wb = window?.XLSX?.utils?.table_to_book?.(
                            refTable.current,
                          )
                          window?.XLSX?.writeFile(
                            wb,
                            `namelist_${batchData?.batch_id}.xlsx`,
                          )
                        }}
                      >
                        <ExportOutlined />
                        Export Name List
                      </Button>
                    </Col>
                    <Col
                      span={24}
                      style={{ width: '800px', overflow: 'scroll' }}
                    >
                      <table ref={refTable} className='puja-table'>
                        <thead>
                          <tr>
                            <th>Pooja Name / ID</th>
                            <th>SKU ID</th>
                            <th>Gotra</th>
                            {findMaxMembersCount?.map(
                              (item: number, index: number) => (
                                <th key={index}>Name {index + 1}</th>
                              ),
                            )}

                            <th>Phone Number</th>
                            <th>WhatsApp Number</th>
                            <th>Opted for prasad</th>
                            <th>Address</th>
                            <th>Pincode</th>
                            <th>Add-ons</th>
                          </tr>
                        </thead>
                        <tbody>
                          {batchData?.pooja_member_data?.map(
                            (pujamembers: PoojaMemberData, index: number) => {
                              return (<tr key={index}>
                                <td>{batchData?.product_name}</td>
                                <td>{batchData?.inventory_id}</td>
                                <td>{pujamembers?.gotra}</td>
                                {findMaxMembersCount?.map(
                                  (index: number) => (
                                    <>
                                      {<td key={index}>{pujamembers?.members?.[index]?.full_name}</td>}
                                    </>
                                  ),
                                )}
                                <td>{pujamembers?.mobile_number}</td>
                                <td>{pujamembers?.whatsapp_number}</td>
                                <td>{pujamembers?.is_opted_for_prasad ? "Yes" : "No"}</td>
                                <td>
                                  {`${pujamembers?.booking_address?.house_info},${pujamembers?.booking_address?.area_info}`}
                                  <br />
                                  {`${pujamembers?.booking_address?.city_name},${pujamembers?.booking_address?.landmark}`}
                                  <br />
                                  {`${pujamembers?.booking_address?.state_name}`}
                                </td>
                                <td>
                                  {pujamembers?.booking_address?.pin_code}
                                </td>
                                <td>
                                  {batchData?.meta_data?.add_ons &&
                                    Object.entries(batchData?.meta_data?.add_ons)
                                      ?.filter(([key, _]) => key === pujamembers?.order_id)?.map((item: any) => (item[1]?.join(' ,  ')))}
                                </td>

                              </tr>)
                            }
                          )}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                ) : (
                  <>
                    {/* <Row justify='end'>
                      <div>
                        <BlobProvider
                          document={
                            <BatchPrintView
                              batchData={batchData}
                              dataType='name_list'
                            />
                          }
                        >
                          {({ blob, loading }) =>
                            loading ? (
                              'Loading document...'
                            ) : (
                              <Button
                                type='primary'
                                onClick={() => {
                                  downloadBlob(
                                    blob,
                                    `namelist_${batchData?.batch_id}.pdf`,
                                  )
                                }}
                              >
                                <ExportOutlined />
                                Export Name List
                              </Button>
                            )
                          }
                        </BlobProvider>
                      </div>
                    </Row> */}
                    <Row>
                      <Col span={24}>
                        {' '}
                        <Typography.Title level={4}>{`Batch ID/Code : ${batchData?.batch_code || batchData?.batch_id
                          }`}</Typography.Title>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={20}>
                        {batchData?.transliterated_names ? (
                          batchData.offering_names.map((originalName: string, index: number) => (
                            <Typography.Title level={4} key={index}>
                              {`${index + 1}. ${batchData?.transliterated_names?.hi[index].output_name || batchData?.transliterated_names?.hi[index].input_name} - [ ${batchData?.transliterated_names?.hi[index].input_name} ]`} {batchData?.meta_data?.quantity_list?.[index] ? `X ${batchData.meta_data.quantity_list[index]}` : ""}
                            </Typography.Title>
                          ))
                        ) : (
                          batchData?.offering_names?.map((name: string, index: number) => (
                            <Typography.Title level={4} key={index}>
                              {`${index + 1}. ${name}`} {batchData?.meta_data?.quantity_list?.[index] ? `X ${batchData.meta_data.quantity_list[index]}` : ""}
                            </Typography.Title>
                          ))
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </TabPane>
              {batchData?.product_type === 'prayer' && (
                <TabPane tab='Prayer List' key='3'>
                  <Row>
                    <Col span={16}>
                      {batchData?.meta_data?.prayer_notes?.map(
                        (prayer_notes: string, index: number) => (
                          <Typography.Title level={4} key={index}>
                            {`${index + 1}. ${prayer_notes}`}
                          </Typography.Title>
                        ),
                      )}
                    </Col>
                    <Col span={8}>
                      <BlobProvider
                        document={
                          <BatchPrintView
                            batchData={batchData}
                            dataType='prayer_list'
                          />
                        }
                      >
                        {({ blob, loading }) =>
                          loading ? (
                            'Loading document...'
                          ) : (
                            <Button
                              type='primary'
                              onClick={() => {
                                downloadBlob(
                                  blob,
                                  `prayer_${batchData?.batch_id}.pdf`,
                                )
                              }}
                            >
                              <ExportOutlined />
                              Export Prayer
                            </Button>
                          )
                        }
                      </BlobProvider>
                    </Col>
                  </Row>
                </TabPane>
              )}
            </Tabs>
          </Col>
        </Row>
      </>
    </Drawer >
  )
}
export default BatchView
